
import * as ipxStaticRuntime$Vjabu2xhClCIYbt3ZN852Qq2mpPZQhhzzw4bGRijhr4 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$Vjabu2xhClCIYbt3ZN852Qq2mpPZQhhzzw4bGRijhr4, defaults: {} }
}
        